var AnalyticsService = /** @class */ (function () {
    function AnalyticsService(api) {
        this.API = api;
    }
    AnalyticsService.prototype.query = function (query) {
        var url = "/".concat(query.eventType, "/").concat(query.timeRange, "?created_at=gt.").concat(query.startDate, "&created_at=lt.").concat(query.endDate);
        if (query.appID) {
            url += "&app=".concat(query.appID);
        }
        if (query.platform) {
            url += "&platform=".concat(query.platform);
        }
        return this.API.get(url);
    };
    return AnalyticsService;
}());
export { AnalyticsService };
